<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ImageBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '200px'
    },
    /** 移动端保留标题条（答题页等），不显示纹理大图 */
    keepTitleOnMobile: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<template>
  <div class="image-bar" :class="{ 'image-bar--keep-title': keepTitleOnMobile }">
    <div v-if="keepTitleOnMobile && title" class="image-bar__mobile-title">
      {{ title }}
    </div>
    <div class="texture-container" :style="{ height: height }">
      <div v-if="title" class="title-overlay">
        <h2>{{ title }}</h2>
      </div>
    </div>
  </div>
</template>

<style scoped>
.image-bar {
  width: 100%;
}

.image-bar__mobile-title {
  display: none;
}

.texture-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-image: url('@/assets/texture-bw.png');
  background-size: auto;
  background-repeat: repeat;
  background-position: center;
}

.title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  text-align: center;
}

.title-overlay h2 {
  margin: 0;
  color: rgb(0, 0, 0);
  font-size: 24px;
  text-align: center;
}
</style>
